/* tslint:disable */
import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';

// Main
import statisticsReport from './modules/main/statisticsReport';
import pendingRequests from './modules/main/pendingRequests';
import authorization from './modules/main/authorization/index';
import backend from './modules/main/backend/index';
import desktopApp from './modules/main/desktopApp/index';
import info from './modules/main/info/index';
import roles from './modules/main/roles/index';
import user from './modules/main/user/index';
import usersGroups from './modules/main/usersGroups/index';
// @ts-ignore
import appleApps from './modules/main/salesReport/index';

// Astrology
import appConfigs from './modules/astrology/appConfigs';
import astroEvents from './modules/astrology/astroEvents/index';
import anotherLifeModel from './modules/astrology/anotherLife/anotherLifeModel/index';
import anotherLifeResult from './modules/astrology/anotherLife/anotherLifeResult/index';
import biorhythms from './modules/astrology/biorhythm/biorhythms/index';
import biorhythmTypes from './modules/astrology/biorhythm/biorhythmTypes/index';
import cookies from './modules/astrology/cookies/index';
import compatibilities from './modules/astrology/compatibility/compatibilities/index';
import compatibilityTypes from './modules/astrology/compatibility/compatibilityTypes/index';
import compatibilityScore from './modules/astrology/compatibility/compatibilityScore/index';
import famousBabyModel from './modules/astrology/famousBaby/famousBabyModel/index';
import famousBabyResult from './modules/astrology/famousBaby/famousBabyResult/index';
import futureBaby from './modules/astrology/futureBaby/index';
// @ts-ignore
import horoscopeAnnuals from './modules/astrology/horoscope/horoscopeAnnuals/index';
// @ts-ignore
import horoscopeDailies from './modules/astrology/horoscope/horoscopeDailies/index';
// @ts-ignore
import horoscopeKeywords from './modules/astrology/horoscope/horoscopeKeywords/index';
// @ts-ignore
import horoscopeMonthlies from './modules/astrology/horoscope/horoscopeMonthlies/index';
// @ts-ignore
import horoscopeTypes from './modules/astrology/horoscope/horoscopeTypes/index';
import houseDescription from './modules/astrology/birthChart/houseDescription/index';
import meditationCategory from './modules/astrology/meditation/meditationCategory/index';
import meditationResource from './modules/astrology/meditation/meditationResource/index';
import moods from './modules/astrology/moods/index';
import moonSigns from './modules/astrology/moonSigns/index';
import numerologyMain from './modules/astrology/numerology/numerologyMain/index';
import numerologyTypes from './modules/astrology/numerology/numerologyTypes/index';

import palmLineMain from './modules/astrology/palmLine/palmLineMain/index';
import palmLineSides from './modules/astrology/palmLine/palmLineSides/index';
import palmLineTypes from './modules/astrology/palmLine/palmLineTypes/index';

import planetDescription from './modules/astrology/birthChart/planetDescription/index';
import planetInSign from './modules/astrology/birthChart/planetInSign/index';

import tarotCard from './modules/astrology/tarot/tarotCard/index';
import tarotFortune from './modules/astrology/tarot/tarotFortune/index';
import tarotResult from './modules/astrology/tarot/tarotResult/index';

import zodiacDescriptions from './modules/astrology/zodiacDescriptions/index';
import zodiacSigns from './modules/astrology/zodiacSigns/index';

import signRelationship from './modules/astrology/signRelationship/index';

import yesOrNo from './modules/astrology/yesOrNo/index';

// CloudFlare
import landingDomain from './modules/cloudflare/landingDomain/index';
import landingRegions from './modules/cloudflare/landingRegions/index';

// VPN
import accessLevels from './modules/vpn/accessLevels/index';
import appleModels from './modules/vpn/appleModels/index';
import blackListDevices from './modules/vpn/blackListDevices/index';
import campaigns from './modules/vpn/campaigns/index';
import campaignTds from './modules/vpn/campaignTds/index';
import cities from './modules/vpn/cities/index';
import clientApps from './modules/vpn/clientApps/index';
import countries from './modules/vpn/countries/index';
import dataCenters from './modules/vpn/dataCenters/index';
import deviceTypes from './modules/vpn/deviceTypes/index';
import landings from './modules/vpn/landings/index';
import landingAttributes from './modules/vpn/landingAttributes/index';
import masterServer from './modules/vpn/masterServer/index';
import osDevices from './modules/vpn/osDevices/index';
import rebills from './modules/vpn/rebills/index';
import receipts from './modules/vpn/receipts/index';
import statistics from './modules/vpn/statistics/index';
import tariffs from './modules/vpn/tariffs';
import tickets from './modules/vpn/tickets';
import trackers from  './modules/vpn/trackers'
import trafficSources from './modules/vpn/trafficSources/index';
import vpns from './modules/vpn/vpns/index';
import mailSubject from './modules/mailSubject';
import partner from './modules/partner';
import premium from './modules/premium';

//Subscriptions

import subscriptionsCampaigns from './modules/subscriptions/campaigns/index';
import subscriptionsTrafficSources from './modules/subscriptions/trafficSources/index';
import subscriptionsLandings from './modules/subscriptions/landings/index';
import subscriptionsAppleModels from './modules/subscriptions/appleModels/index';
import subscriptionsCountries from './modules/subscriptions/countries/index';
import subscriptionsOsDevices from './modules/subscriptions/osDevices/index';
import subscriptionsStatistics from './modules/subscriptions/statistics/index';
import subscriptionsCampaignTds from './modules/subscriptions/campaignTds/index';
import subscriptionsClientApps from './modules/subscriptions/clientApps/index';
import paymentProviderModel from './modules/paymentProviderModel/index';


Vue.use(Vuex);

export default new Vuex.Store({
    state,
    actions: {
        // Main
        ...authorization.actions,
        ...backend.actions,
        ...desktopApp.actions,
        ...info.actions,
        ...roles.actions,
        ...user.actions,
        ...usersGroups.actions,
        ...appleApps.actions,
        ...appConfigs.actions,
        // Astrology
        ...astroEvents.actions,
        ...anotherLifeModel.actions,
        ...anotherLifeResult.actions,
        ...biorhythms.actions,
        ...biorhythmTypes.actions,
        ...cookies.actions,
        ...compatibilities.actions,
        ...compatibilityTypes.actions,
        ...compatibilityScore.actions,
        ...famousBabyModel.actions,
        ...famousBabyResult.actions,
        ...futureBaby.actions,

        ...horoscopeAnnuals.actions,
        ...horoscopeDailies.actions,
        ...horoscopeKeywords.actions,
        ...horoscopeMonthlies.actions,
        ...horoscopeTypes.actions,

        ...houseDescription.actions,

        ...meditationCategory.actions,
        ...meditationResource.actions,

        ...moods.actions,
        ...moonSigns.actions,
        ...numerologyMain.actions,
        ...numerologyTypes.actions,

        ...palmLineMain.actions,
        ...palmLineSides.actions,
        ...palmLineTypes.actions,

        ...planetDescription.actions,
        ...planetInSign.actions,
        ...signRelationship.actions,

        ...tarotCard.actions,
        ...tarotFortune.actions,
        ...tarotResult.actions,
        
        ...zodiacDescriptions.actions,
        ...zodiacSigns.actions,

        // CloudFlare
        ...landingDomain.actions,
        ...landingRegions.actions,

        ...yesOrNo.actions,

        // VPN
        ...accessLevels.actions,
        ...appleModels.actions,
        ...blackListDevices.actions,
        ...campaigns.actions,
        ...campaignTds.actions,
        ...cities.actions,
        ...clientApps.actions,
        ...countries.actions,
        ...dataCenters.actions,
        ...deviceTypes.actions,
        ...landings.actions,
        ...landingAttributes.actions,
        ...masterServer.actions,
        ...osDevices.actions,
        ...rebills.actions,
        ...receipts.actions,
        ...statistics.actions,
        ...tariffs.actions,
        ...tickets.actions,
        ...trackers.actions,
        ...trafficSources.actions,
        ...vpns.actions,

        //Subscriptions
        ...subscriptionsCampaigns.actions,
        ...subscriptionsTrafficSources.actions,
        ...subscriptionsLandings.actions,
        ...subscriptionsAppleModels.actions,
        ...subscriptionsCountries.actions,
        ...subscriptionsOsDevices.actions,
        ...subscriptionsStatistics.actions,
        ...subscriptionsCampaignTds.actions,
        ...subscriptionsClientApps.actions,
    },
    mutations: {
        // Main
        ...pendingRequests.mutations,
        ...appleApps.mutations,
        ...authorization.mutations,
        ...desktopApp.mutations,
        ...roles.mutations,
        ...user.mutations,
        ...usersGroups.mutations,

        // Astrology
        ...astroEvents.mutations,
        ...anotherLifeModel.mutations,
        ...anotherLifeResult.mutations,
        ...biorhythms.mutations,
        ...biorhythmTypes.mutations,
        ...cookies.mutations,
        ...compatibilities.mutations,
        ...compatibilityTypes.mutations,
        ...compatibilityScore.mutations,
        ...famousBabyModel.mutations,
        ...famousBabyResult.mutations,
        ...futureBaby.mutations,

        ...horoscopeAnnuals.mutations,
        ...horoscopeDailies.mutations,
        ...horoscopeKeywords.mutations,
        ...horoscopeMonthlies.mutations,
        ...horoscopeTypes.mutations,

        ...houseDescription.mutations,

        ...meditationCategory.mutations,
        ...meditationResource.mutations,

        ...moods.mutations,
        ...moonSigns.mutations,
        ...numerologyMain.mutations,
        ...numerologyTypes.mutations,

        ...yesOrNo.mutations,

        ...palmLineMain.mutations,
        ...palmLineSides.mutations,
        ...palmLineTypes.mutations,

        ...planetDescription.mutations,
        ...planetInSign.mutations,
        ...signRelationship.mutations,

        ...tarotCard.mutations,
        ...tarotFortune.mutations,
        ...tarotResult.mutations,

        ...zodiacDescriptions.mutations,
        ...zodiacSigns.mutations,

        // CloudFlare
        ...landingDomain.mutations,
        ...landingRegions.mutations,

        // VPN
        ...accessLevels.mutations,
        ...appleModels.mutations,
        ...blackListDevices.mutations,
        ...campaigns.mutations,
        ...campaignTds.mutations,
        ...cities.mutations,
        ...clientApps.mutations,
        ...countries.mutations,
        ...dataCenters.mutations,
        ...deviceTypes.mutations,
        ...landings.mutations,
        ...landingAttributes.mutations,
        ...masterServer.mutations,
        ...osDevices.mutations,
        ...rebills.mutations,
        ...receipts.mutations,
        ...tariffs.mutations,
        ...tickets.mutations,
        ...trackers.mutations,
        ...trafficSources.mutations,
        ...vpns.mutations,

        //Subscriptions
        ...subscriptionsCampaigns.mutations,
        ...subscriptionsTrafficSources.mutations,
        ...subscriptionsLandings.mutations,
        ...subscriptionsAppleModels.mutations,
        ...subscriptionsCountries.mutations,
        ...subscriptionsOsDevices.mutations,
        ...subscriptionsStatistics.mutations,
        ...subscriptionsCampaignTds.mutations,
        ...subscriptionsClientApps.mutations,
    },
    getters: {
        // Main
        ...appleApps.getters,
        ...authorization.getters,
        ...desktopApp.getters,
        ...roles.getters,
        ...user.getters,
        ...usersGroups.getters,

        // Astrology
        ...astroEvents.getters,
        ...anotherLifeModel.getters,
        ...anotherLifeResult.getters,
        ...biorhythms.getters,
        ...biorhythmTypes.getters,
        ...cookies.getters,
        ...compatibilities.getters,
        ...compatibilityTypes.getters,
        ...compatibilityScore.getters,
        ...famousBabyModel.getters,
        ...famousBabyResult.getters,
        ...futureBaby.getters,

        ...horoscopeAnnuals.getters,
        ...horoscopeDailies.getters,
        ...horoscopeKeywords.getters,
        ...horoscopeMonthlies.getters,
        ...horoscopeTypes.getters,

        ...houseDescription.getters,

        ...meditationCategory.getters,
        ...meditationResource.getters,

        ...moods.getters,
        ...moonSigns.getters,
        ...numerologyMain.getters,
        ...numerologyTypes.getters,

        ...yesOrNo.getters,

        ...palmLineMain.getters,
        ...palmLineSides.getters,
        ...palmLineTypes.getters,

        ...planetDescription.getters,
        ...planetInSign.getters,
        ...signRelationship.getters,

        ...tarotCard.getters,
        ...tarotFortune.getters,
        ...tarotResult.getters,

        ...zodiacDescriptions.getters,
        ...zodiacSigns.getters,

        // CloudFlare
        ...landingDomain.getters,
        ...landingRegions.getters,

        // VPN
        ...accessLevels.getters,
        ...appleModels.getters,
        ...blackListDevices.getters,
        ...campaigns.getters,
        ...campaignTds.getters,
        ...cities.getters,
        ...clientApps.getters,
        ...countries.getters,
        ...dataCenters.getters,
        ...deviceTypes.getters,
        ...landings.getters,
        ...landingAttributes.getters,
        ...masterServer.getters,
        ...osDevices.getters,
        ...rebills.getters,
        ...receipts.getters,
        ...tariffs.getters,
        ...tickets.getters,
        ...trackers.getters,
        ...trafficSources.getters,
        ...vpns.getters,

        //getters
        ...subscriptionsCampaigns.getters,
        ...subscriptionsTrafficSources.getters,
        ...subscriptionsLandings.getters,
        ...subscriptionsAppleModels.getters,
        ...subscriptionsCountries.getters,
        ...subscriptionsOsDevices.getters,
        ...subscriptionsStatistics.getters,
        ...subscriptionsCampaignTds.getters,
        ...subscriptionsClientApps.getters,
    },
    modules: {
        statisticsReport,
        mailSubject,
        partner,
        paymentProviderModel,
        premium
    }
});
